// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductReplacement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** String(200) */
  apiLink?: string;
  /** DateTimeOffset */
  confirmedTs?: Date;
  /** String(4) */
  confirmedUserInit?: string;
  /** Guid FK newProduct */
  newProductId!: string;
  /** Guid FK oldProduct */
  oldProductId!: string;
  /** Binary */
  rowVersion!: any;
  /** FK newProductId */
  newProduct!: Product;
  /** FK oldProductId */
  oldProduct!: Product;
}

